import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import {
  Alert,
  Button,
  Checkbox,
  Form,
  Input,
  Modal,
  Popover,
  Typography,
  message,
} from 'antd';
import { SIGN_IN_TEXT } from 'constants/alerts';
import { useDispatch, useSelector } from 'react-redux';
import {
  closeAuthModal,
  login,
  sessionClose,
} from 'store/reducers/authReducer';

function LoginModalForm() {
  const { error, loading, modal } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const checked = Form.useWatch('checked', form);
  const onCancel = () => {
    dispatch(sessionClose());
  };

  const onSubmit = (values) => {
    try {
      dispatch(login({ ...values }));
      dispatch(closeAuthModal());
    } catch (error) {
      message.error('Что-то пошло не так. Попробуйте еще раз', 2);
    }
  };

  return (
    <Modal
      zIndex={1000000}
      visible={modal}
      closable={false}
      title="Вход в систему"
      footer={[
        <Button onClick={onCancel} danger>
          Вернуться к странице логина
        </Button>,
      ]}
    >
      <Form
        layout="horizontal"
        requiredMark={false}
        onFinish={onSubmit}
        form={form}
        labelCol={{
          span: 5,
        }}
        wrapperCol={{
          span: 24,
        }}
        initialValues={{ checked: true }}
      >
        <div className="login-form">
          <div className="login-form__inputs">
            <Form.Item
              name="username"
              label="Email"
              rules={[
                {
                  required: true,
                  message: 'Введите email',
                },
                {
                  pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: 'Некорректный адрес почты',
                },
              ]}
            >
              <Input placeholder="email" />
            </Form.Item>

            <Form.Item
              name="password"
              label="Пароль"
              rules={[
                {
                  required: true,
                  message: 'Введите пароль',
                },
                {
                  min: 8,
                  message: 'Минимум 8 символов',
                },
              ]}
            >
              <Input.Password
                placeholder="password"
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>

            <Form.Item
              wrapperCol={{
                offset: 5,
              }}
              name="checked"
              valuePropName="checked"
            >
              <Checkbox>
                Я соглашаюсь с&nbsp;
                <Popover
                  title="Пользовательское соглашение"
                  content={SIGN_IN_TEXT}
                  trigger="click"
                  overlayStyle={{ width: '360px', zIndex: 1000000 }}
                >
                  <Typography.Link>
                    пользовательским соглашением
                  </Typography.Link>
                </Popover>
              </Checkbox>
            </Form.Item>

            {error && (
              <div className="login-form__error">
                <Alert message={error} type="error" showIcon />
              </div>
            )}

            <Form.Item
              wrapperCol={{
                offset: 5,
              }}
            >
              <Button
                disabled={!checked}
                type="primary"
                loading={loading}
                htmlType="submit"
              >
                Войти
              </Button>
            </Form.Item>
          </div>
        </div>
      </Form>
    </Modal>
  );
}

export { LoginModalForm };
